import React, {useState} from 'react';
import { ITimeProps } from "../../../utils/cellInterfaces";
import {Calendar, CalendarChangeParams} from "primereact/calendar";

const strTimeToDate = (strTime: string) => {
    const split = strTime.split(':')
    if(split.length !== 2) {
        return undefined;
    }

    const timeDate = new Date();
    timeDate.setHours(+split[0])
    timeDate.setMinutes(+split[1])

    return timeDate
}

export function Time(props: ITimeProps) {
    const [time, setTime] = useState<Date | undefined>(strTimeToDate(props.value));

    const handleChangeEvent = (val: CalendarChangeParams) => {
        const timeVal = val.value as Date | undefined
        if(timeVal) {
            setTime(timeVal)
            const changedVal = `${String(timeVal?.getHours()).padStart(2, '0')}:${String(timeVal?.getMinutes()).padStart(2, '0')}`
            props.changeHandler(changedVal);
        } else {
            setTime(undefined)
            props.changeHandler("-");
        }
    }

    if (props.isInEditMode) {
        return <div >
            <Calendar value={time} onChange={handleChangeEvent} placeholder="Time not set" timeOnly stepMinute={1}/>
        </div>
    } else {
        return <div className='p-inputtext' style={{ padding: 'auto', border: 'none', backgroundColor: 'transparent', color:"inherit", whiteSpace:"nowrap" }}>
            { props.value ? (props.value) : ('-') }
        </div>
    }
}
